// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { deactivateExtras } from '@/_helper/deactivateExtras';
import { checkIsAllowToBookService, checkIsAlreadyBooked } from '@/_helper/checkAccess';
import { convertDate, createPaxAges } from '@/_helper/mapper';
import { checkTripStarts } from '@/_helper/checkTripStarts';
import { buildPostRequest } from '@/_helper/apiHelper';

// Komponenten
import TravelTile from '@/comp/travelTile';
import InfoCard from '@/comp/ui/infoCard/infoCard';

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0,
            shineStyle: {},
            isLoading: false,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
        };

        this.isAlreadyBooked = this.isAlreadyBooked.bind(this);
    }

    componentDidMount() {
        let bookingData = storage.get('bookingData');
        this.setState({ bookingData: bookingData });
        if (bookingData != null && bookingData.data != null) {
            this.setState({
                data: storage.get('bookingData').data,
            });
        }

        if (bookingData['load-extraservices'] !== null && bookingData['load-extraservices'] === true) {
            this.setState((state) => {
                state.isLoading = true;
                return state;
            });

            this.checkIsServiceBookable();
        }

        deactivateExtras();
        checkIsAllowToBookService('ExtraServices');
    }

    checkIsServiceBookable() {
        let $this = this;
        let bookingData = storage.get('bookingData');
        let searchParams = undefined;

        let hotelSupplier = '';
        let handlingSupplier = '';
        if (bookingData !== null) {
            searchParams = bookingData.data.searchParams;
            // hotel supplier from serviceInformation.hotel.supplier, if exists
            if (bookingData.data.serviceInformation.hotel !== undefined) {
                if (bookingData.data.serviceInformation.hotel.supplier !== undefined) {
                    hotelSupplier = bookingData.data.serviceInformation.hotel.supplier;
                }
            }

            // handling supplier from serviceInformation.handling.supplier, if exists
            if (bookingData.data.serviceInformation.handling !== undefined) {
                if (bookingData.data.serviceInformation.handling.supplier !== undefined) {
                    handlingSupplier = bookingData.data.serviceInformation.handling.supplier;
                }
            }
        }

        function request(ref, sendData) {
            axios(buildPostRequest(window.$requestUrl, '/searchExtra', JSON.stringify(sendData)))
                .then((response) => response)
                .then((data) => {
                    let offers = data.data.data;
                    if (offers === undefined || offers.length === 0) {
                        window.$content.extras[ref].active = false;
                    }

                    bookingData['load-extraservices'] = false;
                    storage.set('bookingData', bookingData);
                    $this.setState((state) => {
                        state.isLoading = false;
                        return state;
                    });
                })
                .catch(() => {
                    if (window.$content.extras[ref] !== undefined) {
                        window.$content.extras[ref].active = false;
                    }
                });
        }

        if (searchParams !== undefined && !checkTripStarts() && searchParams.adults > 0) {
            // set loading state
            $this.setState((state) => {
                state.isLoading = true;
                return state;
            });

            if (bookingData?.data?.allowTransfer === undefined || bookingData?.data?.allowTransfer !== false) {
                // transfer
                const sendDataTransfer = {
                    requestType: 'searchExtra',
                    travelType: 'transfer',
                    regionCode: searchParams.destination,
                    arrivalAirportCode: searchParams.retAirport,
                    travelStart: convertDate(searchParams.depDate),
                    travelEnd: convertDate(searchParams.retDate),
                    paxAges: createPaxAges(searchParams.paxAges),
                    hotelCodeList: [searchParams.hotelCode],
                    filterTags: [],
                    departureTime: searchParams.transferDepartureTime,
                    returnTime: searchParams.transferArrivalTime,
                    amountAdults: searchParams.adults,
                    clientId: 'customerarea',
                    hotelSupplier: hotelSupplier,
                    handlingSupplier: handlingSupplier,
                };
                request('transfer', sendDataTransfer);
            }

            // insurance
            const sendDataInsurance = {
                requestType: 'searchExtra',
                travelType: 'insurance',
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                filterTags: [],
                amountToBeInsured: parseFloat(searchParams.insuranceAmount),
                clientId: 'customerarea',
            };
            request('insurance', sendDataInsurance);

            // railAndFly
            if (bookingData?.data?.allowRailAndFly) {
                const sendDataRailAndFly = {
                    requestType: 'searchExtra',
                    travelType: 'railAndFly',
                    departureAirportCodes: [searchParams.depAirport],
                    regionCode: searchParams.destination,
                    arrivalAirportCode: searchParams.retAirport,
                    travelStart: convertDate(searchParams.depDate),
                    travelEnd: convertDate(searchParams.retDate),
                    paxAges: createPaxAges(searchParams.paxAges),
                    filterTags: [],
                    clientId: 'customerarea',
                };
                request('railAndFly', sendDataRailAndFly);
            }
        }

        setTimeout(function () {
            $this.setState({ isLoading: false });
            bookingData['load-extraservices'] = false;
            storage.set('bookingData', bookingData);
        }, 5000);
    }

    getRegion() {
        if (this.state != null) {
            const { data } = this.state;

            if (data !== undefined && data.searchParams.destinationDescription !== undefined) {
                return (
                    <span>
                        nach <b>{data.searchParams.destinationDescription}</b>
                    </span>
                );
            }
        }
    }

    isAlreadyBooked(s) {
        const { data } = this.state;

        let checkArr = checkIsAlreadyBooked();

        let returnString = false;
        if (data !== undefined) {
            _.forEach(checkArr, function (value) {
                if (value === 'excursion') {
                    return false;
                }
                if (value === s) {
                    returnString = true;
                }
            });
        }

        return returnString;
    }

    render() {
        const { isLoading } = this.state;

        const items = [];
        Object.keys(window.$content.extras).forEach((k) => {
            const { travelTileTitle, active, link, description, cta, icon } = window.$content.extras[k];

            // check allow book excursion
            if (process.env.VITE_ENV !== 'development' && k === 'excursion') {
                if (!this.state.bookingData.data?.allowExtraServicesExcursion) {
                    return false;
                }
            }

            if (k === 'transfer') {
                if (this.state.bookingData?.data?.allowTransfer === false) {
                    return;
                }
            } else if (k === 'railAndFly') {
                if (
                    this.state.bookingData?.data?.allowRailAndFly === false &&
                    this.state.bookingData.data.serviceInformation.railAndFly === undefined
                ) {
                    return;
                }
            }

            let titleAlreadyBooked = travelTileTitle;
            if (window.$content.extras[k].titleAlreadyBooked !== undefined) {
                titleAlreadyBooked = window.$content.extras[k].titleAlreadyBooked;
            }

            // Fallback :: description alreadyBooked
            if (description.alreadyBooked === undefined) {
                description.alreadyBooked = description.default;
            }

            if (active) {
                items.push(
                    <TravelTile
                        key={k}
                        icon={icon}
                        headline={this.isAlreadyBooked(k) ? titleAlreadyBooked : travelTileTitle}
                        description={this.isAlreadyBooked(k) ? description.alreadyBooked : description.default}
                        cta={cta}
                        state={this.isAlreadyBooked(k) ? 'is-already-booked' : 'show'}
                        link={link}
                        linkType="internal"
                        target="_blank"
                    />
                );
            }
        });

        return (
            <>
                {isLoading ? (
                    Object.keys([0, 1, 2]).map((value, index) => (
                        <TravelTile
                            key={'extraServices-dummy' + index}
                            icon={'attractions'}
                            state={'loading'}
                            target=""
                        />
                    ))
                ) : (
                    <>
                        {items.length === 0 ? (
                            <InfoCard type="small">
                                Für Ihre Reise sind im Moment leider keine Zusatzleistungen verfügbar.
                            </InfoCard>
                        ) : (
                            items
                        )}
                    </>
                )}
            </>
        );
    }
}

export default Index;
